import { stringify } from 'query-string';

interface IGetCustomListsURL {
  sortBy?: string;
  sortOrder?: string;
  expand?: string;
  limit?: number;
}
const getCustomListsURL = (args: IGetCustomListsURL = {}): string => {
  const { sortBy, sortOrder, expand = 'permissions', limit = 999 } = args;

  const params = stringify({
    sortBy,
    expand,
    sortOrder,
    limit,
  });

  return `/api/customEntityLists/me?${params}`;
};

export default getCustomListsURL;
